import { Table } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowDown,
  faArrowUpArrowDown,
} from "@fortawesome/sharp-regular-svg-icons";

import styles from "./sortable-header.module.scss";

type SortableHeaderProps = {
  label: string;
  sortField: string;
  currentSortField: string | null;
  currentSortDirection: "ASC" | "DESC" | null;
  onSort: (field: string, direction: "ASC" | "DESC" | null) => void;
};

const SortableHeader = ({
  label,
  sortField,
  currentSortField,
  currentSortDirection,
  onSort,
}: SortableHeaderProps) => {
  const isActive = currentSortField === sortField;

  const handleClick = () => {
    if (!isActive) {
      onSort(sortField, "DESC");
    } else if (currentSortDirection === "DESC") {
      onSort(sortField, "ASC");
    } else {
      onSort(sortField, null);
    }
  };

  return (
    <Table.Th className={styles.sortableHeader} onClick={handleClick}>
      {label}
      <FontAwesomeIcon
        icon={
          isActive && currentSortDirection === "ASC"
            ? faArrowUp
            : isActive && currentSortDirection === "DESC"
              ? faArrowDown
              : faArrowUpArrowDown
        }
        className={
          isActive && currentSortDirection
            ? styles.sortIcon
            : styles.sortIconInactive
        }
        data-testid="sort-icon"
      />
    </Table.Th>
  );
};

export default SortableHeader;
